import * as React from "react";
import { useTranslation } from "react-i18next";
import { ExpandableListItem } from "components/common";
import { Checkbox } from "components/bootstrap";
const Header = ({ checked, readOnly, onChange, children, indeterminate }) => {
  const { t } = useTranslation("common");
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ React.createElement("span", { onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement(
      Checkbox,
      {
        indeterminate,
        title: t("expandable_checkbox_list_item.select_item"),
        checked,
        readOnly,
        onClick: (e) => e.stopPropagation(),
        onChange: (e) => {
          e.stopPropagation();
          onChange(e);
        },
        inline: true
      },
      children
    ))
  );
};
const ExpandableCheckboxListItem = ({
  checked,
  children = void 0,
  expandable = void 0,
  header,
  indeterminate = void 0,
  onChange,
  readOnly = false,
  subheader = void 0,
  value
}) => /* @__PURE__ */ React.createElement(
  ExpandableListItem,
  {
    value,
    expandable,
    subheader,
    header: /* @__PURE__ */ React.createElement(Header, { onChange, checked, readOnly, indeterminate }, header)
  },
  children
);
export default ExpandableCheckboxListItem;
